<template>
  <div v-if="dataLoaded">
    <router-view></router-view>
  </div>
</template>

<script>
import { session } from "@/utilities/session";
import { JSConn } from "@/utilities/js-conn";

export default {
  name: "app",
  data() {
    return {
      dataLoaded: false,
    };
  },
  mounted() {
    this.dataLoaded = true;
  },
};
</script>

<style lang="scss"></style>
